/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();
import Global from './global';

'use strict';
const MyAccLoader = {

	$domBtn: '.js-change-account',
	classOverlay: 'cart-overlay',

	init: function() {
		$(MyAccLoader.$domBtn).on('click', this.loader);
		this.loginLoader();
		this.showPassword();
		this.loginResetLoader();
	},

	loader: () => {
		Global.$domBody.addClass(MyAccLoader.classOverlay);
		setTimeout(() => {
			Global.$domBody.removeClass(MyAccLoader.classOverlay);
		}, 2000);
	},

	loginLoader: function() {
		$('.woocommerce-form-login__submit').on('click', function() {
			$('.login-button__wrap-loader').show();
		});
	},

	loginResetLoader: function() {
		$('.login-button__wrap-reset-btn').on('click', function() {
			$('.login-button__wrap-loader').show();
		});
	},


	showPassword: function() {
        $('.woocommerce-form__content-box-input-icon').on('click', function() {
			const input = $(this).parent().find('input');
			if (input[0].type === 'password') {
				input[0].type = 'text';
                $(this).addClass('is-active');
			} else {
				input[0].type = 'password';
                $(this).removeClass('is-active');
			}
		});
    },
};

export default MyAccLoader;
